import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-enterprise';
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';
import { AlertService } from 'src/app/services/alert/alert.service';
import { LoadingService } from 'src/app/services/loading/loading.service';
import moment from 'moment';
import AppConstants from 'src/app/shared/common-components/AppConstants';

@Component({
    selector: 'app-tsp-scope',
    templateUrl: './tsp-scope.component.html',
    styleUrls: ['./tsp-scope.component.css'],
    standalone: false
})
export class TspScopeComponent implements OnInit {

  orgId: any;
  orgUpdateForm: UntypedFormGroup;
  redirectedFromBol: any;
  profileName: any;
  messages: any;
  audiTrailData: any;
  columnDefs: (ColDef | ColGroupDef)[];
  updateMessagesOptions: GridOptions = this.initializeGridOptions();
  rowData: any;
  public overlayNoRowsTemplate;
  private gridApi;

  constructor(private formBuilder: UntypedFormBuilder,
              private alertService: AlertService,
              private tmssLoader: LoadingService,
              private route: ActivatedRoute,

              private bsModalRef: BsModalRef,
              public options: ModalOptions,
  ) {
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No rows to display, please adjust your filters</span>';
    this.orgUpdateForm = this.formBuilder.group({
      newMessage: new UntypedFormControl('')
    });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        flex: 1,
        wrapText: true,
        autoHeight: true,
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      rowData: this.audiTrailData,
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
  }

  /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    // params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    this.gridApi.setHeaderHeight(30);
  }


  ngOnInit() {

    this.audiTrailData = this.options.initialState;
    this.rowData = this.audiTrailData.auditTrailLogList;
    this.updateColumnDefs();
    this.profileName = this.audiTrailData.profile;
    this.tmssLoader.hide();
  }


  updateColumnDefs() {
    this.columnDefs = this.getUpdateMessagesOptionsColumnDefs();
  }

  getUpdateMessagesOptionsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          flex: 1,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          headerName: 'Scope Type',
          field: 'scopeType',
          filter: 'agTextColumnFilter',
          sortable: true

        },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Origin Name',
        field: 'originName',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Destination Name',
        field: 'destinationName',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Updated By',
        field: 'userId',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Updated Date',
        field: 'updateDate',
        cellRenderer: (data) => {
          return data.value ? (new Date(data.value)).toLocaleDateString() : '';
        }
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Action Type',
        field: 'actionType',
        filter: 'agTextColumnFilter',
        sortable: true
      }
    ];
  }

  closeModal() {
    this.bsModalRef.hide();

  }


}
